module.exports = __webpack_public_path__ + "img/status-intransit-active.99ece47c.svg";